/** One fixed conversion for customer projects; UI and persisted dimensions use metres. */
export const PROJECT_UNITS_PER_METRE = 10;
export const DEFAULT_PROJECT_METRICS = {version:1, units_per_metre:PROJECT_UNITS_PER_METRE,
  module_width_m:1.134,module_length_m:1.722,module_gap_m:0.02,frame_height_m:0.3,
  active_lift_m:0.6,park_drop_m:0.5,source:'Annahme – Modulmaße noch bestätigen'};
export type ProjectMetrics = typeof DEFAULT_PROJECT_METRICS;
export function projectMetrics(value: Partial<ProjectMetrics> = {}): ProjectMetrics {
  const result={...DEFAULT_PROJECT_METRICS,...value,version:1,units_per_metre:PROJECT_UNITS_PER_METRE};
  for(const key of ['module_width_m','module_length_m','frame_height_m'] as const)
    if(!Number.isFinite(result[key])||result[key]<=0||result[key]>10)throw new Error('Ungültige Modul- oder Gestellmaße.');
  for(const key of ['module_gap_m','active_lift_m','park_drop_m'] as const)
    if(!Number.isFinite(result[key])||result[key]<0||result[key]>5)throw new Error('Ungültiger Abstand.');
  return result;
}
export function metricRackSize(cols:number,rows:number,landscape:boolean,value:ProjectMetrics) {
  const m=projectMetrics(value),u=PROJECT_UNITS_PER_METRE;
  const moduleWidth=(landscape?m.module_length_m:m.module_width_m)*u;
  const moduleDepth=(landscape?m.module_width_m:m.module_length_m)*u;
  return {width:cols*moduleWidth+(cols-1)*m.module_gap_m*u,
    depth:rows*moduleDepth+(rows-1)*m.module_gap_m*u,
    height:m.frame_height_m*u,moduleWidth,moduleDepth,gap:m.module_gap_m*u};
}
